import { serverHost } from "./config";

const authHeader = () => {
  return `Bearer ${localStorage.getItem("login_token")}`;
};

export const httpGet = async (path: string) => {
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: authHeader(),
    },
  };

  return await doRequest(path, options);
};

export const httpPost = async (path: string, payload: any) => {
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: authHeader(),
    },
    body: JSON.stringify(payload),
  };

  return await doRequest(path, options);
};

export const httpPatch = async (path: string, payload: any) => {
  const options = {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: authHeader(),
    },
    body: JSON.stringify(payload),
  };

  return await doRequest(path, options);
};

export const httpDelete = async (path: string) => {
  const options = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: authHeader(),
    },
  };

  return await doRequest(path, options);
};

const doRequest = async (path: string, options: RequestInit) => {
  const fullUrl = serverHost() + path;

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 10000);

  try {
    const result = await fetch(fullUrl, {
      ...options,
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (result.status >= 200 && result.status < 204) {
      return {
        error: null,
        body: await result.json(),
        fromCache: false,
      };
    } else if (result.status === 204) {
      return {
        error: null,
        body: null,
        fromCache: false,
      };
    } else if ([401, 403].includes(result.status)) {
      localStorage.removeItem("login_token");

      return {
        error: "logged_out",
        body: null,
        fromCache: false,
      };
    } else if (result.status === 503) {
      return {
        error: "offline",
        body: await result.json(),
        fromCache: true,
      };
    } else {
      return {
        error: result.status,
        body: await result.json(),
        fromCache: false,
      };
    }
  } catch (e) {
    clearTimeout(timeoutId);

    if (e instanceof Error && e.name === "AbortError") {
      return {
        error: "timeout",
        body: null,
        fromCache: false,
      };
    }

    return {
      error: "request_failed",
      body: null,
      fromCache: false,
    };
  }
};
